import { createLogger } from './loggerCreator'

const log = createLogger('ga', 'cadetblue', undefined, true)
let gaProxy = (...args: any[]) => {
  if (BUILD_MODE === 'dev') {
    log.log(...args)
  }
}

function ga(...args: any[]) {
  gaProxy(...args)
}

ga.init = function init(trackingCode: string) {
  ;(function (i: any, s: any, o: any, g: any, r: any, a?: any, m?: any) {
    i['GoogleAnalyticsObject'] = r
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;((i[r] =
      i[r] ||
      function () {
        // eslint-disable-next-line prefer-rest-params
        ;(i[r].q = i[r].q || []).push(arguments)
      }),
      (i[r].l = new Date().getTime()))
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;((a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]))
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')

  const ga = (window as any).ga
  ga('create', trackingCode, 'auto')
  gaProxy = (...args) => ga(...args)
}

export default ga
